
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hairstyle-changer",
      function () {
        return require("private-next-pages/hairstyle-changer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hairstyle-changer"])
      });
    }
  